import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "--",
	},

	...createdAtmodifiedAtActions,
];
